export default __webpack_public_path__ + "static/media/laundry-room.75e0bc9e.jpg";